(function () {
  class CreditScore extends Common {
    constructor() {
      super()
    };

    configure() {
      // BY Ids
      this.ui.submitBtn = "#submitBtn";
      this.ui.deviceNameSelect = "#brand_name";
      this.ui.brandsSelect = "#credit_score_range_brands"
      this.ui.csrType = "#credit_score_range_csr_type";
      this.ui.scoreFrom = "#credit_score_range_score_from";
      this.ui.scoreTo = "#credit_score_range_score_to";
      this.ui.actionType = "#credit_score_range_action_type";
      this.ui.initialPayment = "#credit_score_range_initial_payments";
      this.ui.maxAmount = "#credit_score_range_max_amount";

      //By class
      this.ui.rangeListLink = ".js-range-list-link";
    };

    approved(slug, message) {
      const operation = this;

      if (operation.loanFlowVersion() === "v2") {
        operation.approvedV2(slug, message);
        return;
      }

      Swal.fire({
        html: message,
        icon: 'success',
        showCloseButton: true,
        showDenyButton: true,
        showCancelButton: true,
        cancelButtonText: i18n.t('commons.decline'),
        cancelButtonColor: "#dc3545",
        confirmButtonText: i18n.t('commons.continue_with_loan'),
        confirmButtonColor: "#69BE5A",
        denyButtonText: i18n.t('commons.device_list'),
        denyButtonColor: "#7066e0",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = operation.newLoanPath({ slug: slug });
        } else if (result.isDenied) {
          $.ajax({
            method: "GET",
            url: Routes.device_list_credit_infos_path({ slug: slug }),
            dataType: 'script',
          }).done(function () {
            console.log("Done!");
          }).fail(function () {
            console.log("Error");
          });
        } else {
          window.location.href = operation.newCustomerConsentPath();
        }
      });
    };

    // V2: create the loan and auto-preapprove identity after digital APC SMS.
    approvedV2(slug, message) {
      this.requestV2Approval(slug, message);
    }

    // Shown to the seller after the first (identity) approval is granted.
    showPrequalificationAfterApproval(slug, message, nextUrl) {
      window.__v2PrequalificationNextUrl = nextUrl || "";
      window.__v2PrequalificationSlug = slug || "";

      Swal.fire({
        html: message,
        icon: "success",
        showCloseButton: true,
        showDenyButton: true,
        showCancelButton: true,
        cancelButtonText: i18n.t("commons.decline"),
        cancelButtonColor: "#dc3545",
        confirmButtonText: i18n.t("commons.continue_with_loan"),
        confirmButtonColor: "#69BE5A",
        denyButtonText: i18n.t("commons.device_list"),
        denyButtonColor: "#7066e0",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (nextUrl) {
            window.location.href = nextUrl;
          }
        } else if (result.isDenied) {
          $.ajax({
            method: "GET",
            url: Routes.device_list_credit_infos_path({ slug: slug }),
            dataType: "script",
          }).fail(function () {
            console.log("Error loading device list");
          });
        } else {
          window.location.href = "/loans";
        }
      });
    }

    requestV2Approval(slug, message) {
      const operation = this;
      $('.bootbox.modal').modal('hide');

      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        message: i18n.t("bootbox.processing_html") || "Enviando a aprobación...",
      });

      const csrf =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
      const url =
        window.Routes && typeof Routes.request_approval_v2_loans_path === "function"
          ? Routes.request_approval_v2_loans_path()
          : "/v2/loans/request_approval";

      fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrf,
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ slug: slug }),
        credentials: "same-origin",
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));
          if (!response.ok || !data.success) {
            const err =
              (data.errors && data.errors.join("<br>")) ||
              "No se pudo enviar a aprobación. Intente de nuevo.";
            throw new Error(err);
          }
          return data;
        })
        .then((data) => {
          $(".bootbox.modal").modal("hide");
          if (typeof LoanV2 !== "undefined") {
            const loanV2 = new LoanV2();
            loanV2.configure();
            loanV2.openWaitingModal(
              Object.assign({}, data, {
                prequalification_message: data.prequalification_message || message,
                consent_slug: data.consent_slug || slug,
              })
            );
          } else if (data.loans_index_url || data.loans_index_url) {
            window.location.href = data.loans_index_url || data.loans_index_url;
          }
        })
        .catch((err) => {
          $(".bootbox.modal").modal("hide");
          bootbox.alert(err.message || "No se pudo enviar a aprobación.");
        });
    }

    maxAttempsFailed(message) {
      const operation = this;
      var failedMessage = i18n.t('bootbox.errors.message_html', { message: message + "<br>" + i18n.t('commons.contact_admin') })

      bootbox.alert(failedMessage, function () {
        location.reload();
      });
    };

    check(slug) {
      const operation = this;

      $('.bootbox.modal').modal('hide');

      $(operation.ui.submitBtn).attr('disabled', true);
      $(operation.ui.submitBtn).text(i18n.t('commons.processing'));

      //setTimeout(function () {
      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        message: i18n.t('bootbox.consulting_profile_credit_score_html')
      });
      //}, 550);

      setTimeout(function () {
        $.ajax({
          url: Routes.credit_score_credit_infos_path({ slug: slug, format: "js" }),
          type: 'GET',
          //dataType: 'json',
          async: false,
          complete: function () {
            operation.hideBootBox();
            $('.bootbox.modal').modal('hide');
          }
        });
      }, 550);
    };

    checkAgain(slug, person_id) {
      // Metodo usado para API Consentimiento (Preview) - Equifax
      const operation = this;
      $('.bootbox.modal').modal('hide');
      $(operation.ui.submitBtn).attr('disabled', true);
      $(operation.ui.submitBtn).text(i18n.t('commons.processing'));

      Swal.fire({
        html: i18n.t('credit_score.messages.check_again_html'),
        icon: 'success',
        showCloseButton: true,
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: i18n.t('commons.cancel'),
        cancelButtonColor: "#dc3545",
        confirmButtonText: i18n.t('commons.check_again'),
        confirmButtonColor: "#1852A9",
        //denyButtonText: i18n.t('commons.preview_consent'),
        //denyButtonColor: "#7066e0",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          operation.configure();
          operation.check(slug);
          //} else if (result.isDenied) {
          //  var win = window.open(Routes.preview_customer_consents_path({ person_id: person_id }), '_blank');
          //  win.focus();
          //  operation.configure();
          //  operation.checkAgain(slug, person_id);
        } else {
          window.location.href = operation.newCustomerConsentPath();
        }
      });
    };

    checkFailed(slug, message) {
      const operation = this;
      var failedMessage = i18n.t('bootbox.errors.message_html', { message: message });

      bootbox.confirm({
        message: failedMessage,
        buttons: {
          confirm: {
            label: i18n.t('commons.check_again'),
            className: 'btn-success'
          },
          cancel: {
            label: i18n.t('commons.cancel'),
            className: 'btn-danger'
          }
        },
        callback: function (result) {
          if (result) {
            operation.configure();
            operation.check(slug);
          } else {
            window.location.href = operation.newCustomerConsentPath();
          }
        }
      });
    };

    creditScoreLabel() {
      const operation = this;

      $(operation.ui.csrType).on('change', function () {
        var selected = $(this).find('option:selected').val();

        if (selected == 'credit_score') {
          $(operation.ui.scoreFrom).closest(".form-group").find("label").text(i18n.t('activerecord.attributes.credit_score_range.score_from'));
          $(operation.ui.scoreTo).closest(".form-group").find("label").text(i18n.t('activerecord.attributes.credit_score_range.score_to'));
        } else {
          $(operation.ui.scoreFrom).closest(".form-group").find("label").text(i18n.t('commons.purchased_from'));
          $(operation.ui.scoreTo).closest(".form-group").find("label").text(i18n.t('commons.purchased_up_to'));
        };
      });
    };

    creditScoreRangesList() {
      const operation = this;

      $(operation.ui.rangeListLink).on('click', function () {
        var csr_type = $(this).find('a.nav-link.tab-link').data('id');

        $.ajax({
          method: "GET",
          url: Routes.credit_score_ranges_path({ q: { csr_type_eq: csr_type } }),
          dataType: 'script',
        }).done(function () {
          console.log("done")
        }).fail(function () {
        });
      });
    };

    deviceList(company_id) {
      const operation = this;
      $(operation.ui.deviceNameSelect).on('change', function () {
        var selected = parseInt($(this).find('option:selected').val());
        var devices = $('.js-root-web').data('approvedDevices');

        var device = devices.filter(function (device) {
          return device.brands.includes(selected) || device.brands.length === 0;
        }).reduce(function (max, device) {
          return device.max_amount > max.max_amount ? device : max;
        });

        $.ajax({
          method: "GET",
          url: Routes.js_device_models_path(),
          data: { object_id: selected, max_price: device['max_amount'], company_id: company_id }
          //dataType: 'script',
        }).done(function (data) {
          $("#device-name").html("");
          var resultsArray = data.results
          for (var i = 0; i < resultsArray.length; i++) {
            $('<div class="col-3 dot">').text(resultsArray[i]['text']).appendTo('#device-name');
          };
        }).fail(function () {
          console.log("Error");
        });
      });
    };

    loanFlowVersion() {
      return gon.loan_flow_version === "v2" ? "v2" : "v1";
    }

    newLoanPath(opts) {
      return this.loanFlowVersion() === "v2"
        ? Routes.new_v2_loan_path(opts)
        : Routes.new_v1_loan_path(opts);
    }

    newCustomerConsentPath() {
      return this.loanFlowVersion() === "v2"
        ? Routes.new_v2_customer_consent_path()
        : Routes.new_v1_customer_consent_path();
    }
  };

  window.CreditScore = CreditScore;
})();
